import React, { useState, useEffect } from 'react';
import ReactQuill from 'react-quill';
import { editorConstant } from '../../helper/staticHelper.js';
import { saveSignature, getSignature } from '../../helper/apiHelper.js'
import { toast, Bounce } from 'react-toastify';

function Signature() {
    const [note, setNote] = useState('');
    const [isHtml, setIsHtml] = useState(false);
    const [isActive, setIsActive] = useState(false);

    const handleRadioChange = (value, type) => {
        if (type === 'isHtml') {
            setIsHtml(value === 'true');
        }
        if (type === 'isActive') {
            setIsActive(value === 'true');
        }
    };

    const save = async () => {
        const data = {
            isHtml: isHtml,
            isActive: isActive,
            note: note
        }
        const result = await saveSignature(JSON.stringify(data));
        if (result) {
            toast.success("Saved!", {
                position: "top-center",
                transition: Bounce,
            });
        } else {
            toast.error("Something went wrong!", {
                position: "top-center",
                transition: Bounce,
            });
        }
        fetchData();
    }

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            const response = await getSignature();
            if (response) {
                setIsActive(response.is_active);
                setIsHtml(response.is_html);
                setNote(response.signature);
            }

        } catch (error) {
            console.error('Error fetching general settings:', error);
        }
    };

    return (
        <>
            <div className='col'>
                <div className='general-section container-fluid'>
                    <div className="row border-bottom general-row">
                        <div className="col-4">
                            <div className="general-menu-text">Use html</div>
                        </div>
                        <div className="col d-flex justify-content-center flex-column gap-2">
                            <label className="d-flex align-items-center cursor-pointer w-fit-content">
                                <input type="radio" className="input-radio on" name="Use html-0" value="true"
                                    checked={isHtml}
                                    onChange={(event) => { handleRadioChange(event.target.value, 'isHtml') }} />
                                Enable
                            </label>
                            <label className="d-flex align-items-center cursor-pointer w-fit-content">
                                <input type="radio" className="input-radio on" name="Use html-0" value="false"
                                    checked={!isHtml}
                                    onChange={(event) => { handleRadioChange(event.target.value, 'isHtml') }} />
                                Disable
                            </label>
                        </div>
                    </div>

                    <div className="row border-bottom general-row">
                        <div className="col-4"><div className="general-menu-text">Active</div>
                        </div>
                        <div className="col d-flex justify-content-center flex-column gap-2">
                            <label className="d-flex align-items-center cursor-pointer w-fit-content">
                                <input type="radio" className="input-radio on" name="Active-1" value="true"
                                    checked={isActive}
                                    onChange={(event) => { handleRadioChange(event.target.value, 'isActive') }} />
                                Enable
                            </label>
                            <label className="d-flex align-items-center cursor-pointer w-fit-content">
                                <input type="radio" className="input-radio on" name="Active-1" value="false"
                                    checked={!isActive}
                                    onChange={(event) => { handleRadioChange(event.target.value, 'isActive') }} />
                                Disable
                            </label>
                        </div>
                    </div>

                    <div className="row border-bottom general-row">
                        <div className="col-4"><div className="general-menu-text">Signature</div>
                        </div>
                        <div className="col d-flex justify-content-center flex-column gap-2">
                            <ReactQuill className="eventEditor mt-2" modules={{
                                toolbar: editorConstant.toolBar,
                            }} value={note} onChange={(e) => setNote(e)} />
                        </div>
                    </div>

                    <div className='general-submit col-4 d-flex justify-content-end'>
                        <button className='general-save-btn' onClick={async () => {
                            await save();
                        }}>Save</button>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Signature;
